<template>
	<div class="parts_table mt-4">
		<div class="push_item mb-4">
			<div>
				<button type="button" class="btn btn-lg btn-default waves-effect waves-themed width-xl"  v-on:click="add_row(false)">
					<span class="fal  fa-plus mr-1"></span>
					За каталогом
				</button>
			</div>

			<div class="mt-2">
				<button type="button" class="btn btn-lg width-xl  btn-outline-info waves-effect waves-themed"
						v-on:click="add_manual_row">
					<span class="fal  fa-plus mr-1"></span>
					Вручну
				</button>
			</div>
		</div>

		<div class="head">
			<b-table  head-variant="dark"
					  :tbody-tr-class="checkRow"
					  :items="part_fields_items"
					  :fields="fields"
			>
				<template  v-slot:cell(name)="data" >
					<b-form-input
						type="text"
						class="fs-xl"
						:readonly=!data.item.is_manual
						:disabled="parseInt(data.item.id) > 0"
						value="data.name"
						v-model="data.item.name"
						size="sm" >
					</b-form-input>
				</template>

				<template  v-slot:cell(numberOriginal)="data" >
					<div>
						<part_item
							v-if="(data.item.is_manual == false && parseInt(data.item.id) == 0)"
							@on_select_part="on_select_part"
							:key="'idx_' + data.index"
							:table_item="data"
							item_type="original"></part_item>

						<b-form-input
							v-else
							type="text"
							placeholder="Каталожний номер"
							:disabled="parseInt(data.item.id) > 0"
							class="fs-xl"
							value="data.name"
							v-model="data.item.numberOriginal"
							size="sm" >
						</b-form-input>
					</div>
				</template>

				<template  v-slot:cell(qty)="data" >
					<b-form-input
						type="text"
						class="fs-xl"
						placeholder="К-ть"
						v-model=data.item.qty
						size="sm" >
					</b-form-input>
				</template>

				<template  v-slot:cell(measure)="data" >
					<b-form-input
						type="text"
						:disabled="parseInt(data.item.id) > 0"
						:readonly=!data.item.is_manual
						class="fs-xl"
						placeholder="Од. виміру"
						v-model=data.item.measure
						size="sm" >
					</b-form-input>
				</template>

				<template v-slot:cell(code)="data" >
					<div class="remove_row" @click="remove_row(data.index)">
						<i class="fa fa-trash active color-danger-800 cursor-pointer fs-xl mt-2 ml-1" aria-hidden="true"></i>
					</div>
				</template>
			</b-table>
		</div>

	</div>
</template>

<script>
import vSelect from 'vue-select'
import Part_item from "./part_item/part_item_search";

export default {
	name: "parts_items",

	props : {
		parts_field : {
			type : Object
		},
		exist_parts : {
			type : Array
		},
	},

	components: {
		Part_item,
		vSelect
	},

	data() {
    return {
      fields: [
        {
          key: 'name',
          label: 'Назва',
          class: 'part_name'
        },
        {
          key: 'numberOriginal',
          label: 'Каталожний номер',
          class: 'part_catalog'
        },
        {
          key: 'qty',
          label: 'К-ть',
          class: 'part_small'
        },
        {
          key: 'measure',
          label: 'Од. виміру',
          class: 'part_middle'
        },
        {
          key: 'code',
          label: "",
          class: "remove"
        }
      ],
      items: []
    }
  },

	created() {

	},

	methods : {

		checkRow(item, type) {
			if(item.hasOwnProperty("is_manual")) {
				if(item.is_manual) {
					return 'mobile_ready bg-primary-50';
				}
			}

			return 'mobile_ready';
		},

		on_select_part(obj)  {
			console.log('on_select_part',obj);
			let cur_type = obj.type;
			let idx = obj.idx;
			let selected_part = obj.selected_part;

			this.part_fields_items[idx].measure = '';
			this.part_fields_items[idx].name = '';
          this.part_fields_items[idx].code_1c = '';
    
          this.part_fields_items[idx].selected_item.original = selected_part;
          this.part_fields_items[idx].selected_item.non_original = null;


			/*if(cur_type == 'non_original') {
				if(this.obj_to_null(selected_part)) {
					this.part_fields_items[idx].selected_item.original = selected_part;
				}
				this.part_fields_items[idx].selected_item.non_original 	= selected_part;
			}*/


			if(this.obj_to_null(this.part_fields_items[idx].selected_item.original)) {
				this.part_fields_items[idx].measure = this.part_fields_items[idx].selected_item.original.measure;
				this.part_fields_items[idx].name = this.part_fields_items[idx].selected_item.original.name;
                this.part_fields_items[idx].code_1c = this.part_fields_items[idx].selected_item.original.code;
			}
		},

		on_select_os(obj) {

		},

		change_row() {

		},


		add_manual_row() {
			this.add_row(true)
		},

		add_row(is_manual = false) {
			this.part_fields_items.push({
				id : 0,
				name: is_manual ? '' : 'Не обрано',
				numberOriginal: '',
				qty: 0,
				is_manual : is_manual,
				measure: '',
				'selected_item' : {
					'original' : null,
				}
			});
			this.$emit('change_fields',this.part_fields_items);
		},

		onSearchNonOriginal(search, loading) {
			if(search.length > 2) {
				loading(true);
				this.search(loading, search,'non_original');
			}
		},

		remove_row(idx) {
			this.part_fields_items.splice(idx,1);
			this.$emit('change_fields',this.part_fields_items);
		}
	},
	computed : {
		part_fields_items() {
			try {
				let base_items =  this.parts_field.insert_val;
				base_items = base_items.map(item => {
					item.id = 0;
					return item;
				});

				console.log(base_items);

				try {
					if(this.exist_parts.length > 0) {
						if(this.obj_to_null(this.exist_parts)) {
							this.exist_parts.map(exist_part => {
								let filed_push = exist_part.field_json;
								filed_push.id = parseInt(exist_part.id);
								base_items.push(filed_push);
							});
						}
					}
				}
				catch (e) {

				}

				this.parts_field.insert_val = base_items;

				return base_items;
			}
			catch (e) {

			}

			return [];
		}



	},
}
</script>

<style scoped>

</style>
